import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";

const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const start = Date.now();

    logEvent(analytics, "page_view", {
      page_path: location.pathname,
      page_title: document.title,
    });

    return () => {
      const duration = Date.now() - start;

     
      const secondsSpent = Math.round(duration / 1000);

      logEvent(analytics, "page_time_spent", {
        page_path: location.pathname,
        time_spent_seconds: secondsSpent,
      });
    };
  }, [location.pathname]); 
};

export default useAnalytics;
